export default __webpack_public_path__ + "static/media/Forsidebillede.71e5f0ef.jpg";